export default __webpack_public_path__ + "static/logo-pp-9ce199927aa964a13d3ad2d16e1e1f75.svg";